export const withinTheTimeLimit = (item: any, today: Date) => {
  if (item.startDate && !item.endDate) {
    // Se houver apenas data de início, verificar se a data de início é no futuro
    return new Date(item.startDate) >= today;
  } else if (!item.startDate && item.endDate) {
    // Se houver apenas data de fim, verificar se a data de fim é no futuro
    return new Date(item.endDate) >= today;
  } else if (item.startDate && item.endDate) {
    // Se houver tanto data de início quanto data de fim, verificar se o dia atual está entre as duas datas
    const dataInicio = new Date(item.startDate);
    const dataFim = new Date(item.endDate);
    return today >= dataInicio && today <= dataFim;
  } else {
    // Se não houver datas, manter o elemento
    return true;
  }
};

export const formatDate = (date: string) => {
  const _date = new Date(date);
  const day = _date.getDate().toString().padStart(2, "0");
  const month = (_date.getMonth() + 1).toString().padStart(2, "0");
  // const ano = dataObj.getFullYear();
  return `${day}/${month}`;
};
